<!-- modal popup window -->
<template>
  <div class="modal-backdrop">
    <div class="window-area">
      
      <div class="row justify-center text-center mt-4">
        <div class="col-12">
          <h2>{{textValue}}</h2>
        </div>
      </div>

      <div class="row text-center">
        <div class="col-12">
          <button type="submit" class="btn btn-success" @click="yesClick()">Okay</button>
        </div>
      </div>
                
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {}
  },
  props: ['textValue'],
  mounted: function() {
    //called on launch
  },
  methods: {
    yesClick: function() {
      this.$emit('yes-click')
    }
  }
}

</script>

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .window-area {
    width: 500px;
    height: 350px;
    padding: 20px;
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
  }

  .modal {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
  }
</style>